import type { TiktokShopResponse } from '@/features/Setting/Integrations/integrationRedirection/tiktokshop';
import type { TiktokShopWorkspaceT } from '@/features/Setting/Integrations/providers/types';
import { v1ApiClient } from '@/services/index';

const tiktokshopService = {
  async createTiktokShopInfo(
    code: string,
    workspaceAlias: string,
  ): Promise<TiktokShopResponse> {
    const res = await v1ApiClient.post(
      `/workspaces/${workspaceAlias}/tiktokshop`,
      { auth_code: code },
    );
    return res.data;
  },
  async getTiktokShopInfo(
    workspaceAlias: string,
  ): Promise<TiktokShopWorkspaceT> {
    const res = await v1ApiClient.get(
      `/workspaces/${workspaceAlias}/tiktokshop`,
    );
    return res.data;
  },
  async importWorkspaceFeedback(
    alias: string,
    startDate: string,
    endDate: string,
  ) {
    const res = await v1ApiClient.post(
      `/workspaces/${alias}/tiktokshop/import`,
      {
        start_date: startDate,
        end_date: endDate,
      },
    );
    return res.data;
  },
  async deleteTiktokShopInfo(alias: string) {
    try {
      const res = await v1ApiClient.delete(`/workspaces/${alias}/tiktokshop`);
      return res.data;
    } catch (e) {
      return false;
    }
  },
};

export default tiktokshopService;
